import React from 'react';
import { connect } from 'react-redux';

import { APP_TYPES } from '@config';
import {
  setWorkingLifeValue
} from '@reducers/selectors/design/actions';
import { APP_TEXTS } from '../../../../texts/texts';


const WorkingLife = props => ( 
  <div className="d-flex mt-2 list-type">
    <b>
      {APP_TEXTS.WORKING_LIFE.Content}
    </b>

    <div className="d-flex flex-column ml-4">
      <label htmlFor="years_50">
        <input
            id="years_50"
            type="radio"
            name="years_50"
            onChange={(e) => props.setWorkingLifeValue(50)}
            checked={props.wl === 50}
        />
        <b>
          &nbsp;
          {APP_TEXTS.WORKING_LIFE_50_YEARS.Content}
        </b>
      </label>

      <label htmlFor="years_100">
        <input
          id="years_100"
          type="radio"
          name="years_100"
          onChange={(e) => props.setWorkingLifeValue(100)}
          checked={props.wl === 100}
        />
        <b>
          &nbsp;
          {APP_TEXTS.WORKING_LIFE_100_YEARS.Content}
        </b>
      </label>
    </div>
  </div>
);

const mapState = state => ({
  wl: state.selectors.design[APP_TYPES.GENERAL_CALCULATION].workingLife,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = dispatch => ({
  setWorkingLifeValue: value => dispatch(setWorkingLifeValue(value)),
});

export default connect(mapState, mapDispatch)(WorkingLife);



// WEBPACK FOOTER //
// ./src/views/Design/components/GeneralCalculationDesign/WorkingLife.js